// Utilities
import { formatPhoneNumber } from "../../../services/global.services";

// State management
import { useAppSelector } from "../../../services/StoreHelper";

// Styles
import club_details_styles from "./club_details_styles";

function ClubDetails() {
  const { club } = useAppSelector((state) => state.app);

  // 🔹 Toggle language here (can be lifted to Redux later)
  const { usesSpanish } = club;

  // 🔹 Inline translations
  const TEXT = {
    address: usesSpanish ? "Dirección" : "Address",
    phone: usesSpanish ? "Teléfono" : "Phone",
  };

  return (
    <div style={club_details_styles.club_details}>
      <h1 style={club_details_styles.club_name}>{club.name}</h1>

      <div style={club_details_styles.details}>
        <h5 style={club_details_styles.data}>
          {TEXT.address}: {club.street}
        </h5>

        <h5 style={club_details_styles.data}>
          {club.city}, {club.state} {club.zip}
        </h5>

        <h5 style={club_details_styles.data}>
          {TEXT.phone}: {formatPhoneNumber(club.phone)}
        </h5>
      </div>
    </div>
  );
}

export default ClubDetails;